import type { Node_Type, RichContent, TextStyle_TextAlignment } from './../ricos-schema/legacy/wix/rich_content/v1';

import * as browser from './browser';

// Components
export { default as InlineToolbarButton } from './Components/InlineToolbarButton';
export { default as RicosPortal } from './Components/RicosPortal';
export { default as ToolbarButton } from './Components/ToolbarButton';

//Utils
export {
  BUTTON_TYPES,
  FORMATTING_BUTTONS,
  INSERT_PLUGIN_BUTTONS,
  KEYS_CHARCODE,
  RICOS_TIPTAP_EDITOR_DATA_HOOK,
  TOOLBARS,
} from './consts';
export { default as decorateComponentWithProps } from './Utils/decorateComponentWithProps';
export { isiOS } from './Utils/isiOS';
export { mergeToolbarSettings } from './Utils/mergeToolbarSettings';
export { isTextSelection } from './Utils/tiptap/isTextSelection';

import { v4 as uuid } from 'uuid';

export const getEmptyContent: () => RichContent = () => ({
  nodes: [
    {
      type: 'PARAGRAPH' as Node_Type,
      id: 'foo',
      nodes: [],
      paragraphData: {
        textStyle: {
          textAlignment: 'AUTO' as TextStyle_TextAlignment,
        },
        indentation: 0,
      },
    },
  ],
  metadata: {
    version: 1,
    createdTimestamp: '2022-12-19T17:56:18.279Z' as unknown as Date,
    updatedTimestamp: '2022-12-19T17:56:18.279Z' as unknown as Date,
    id: uuid(),
  },
  documentStyle: {},
});

export { PLUGIN_TOOLBAR_BUTTON_ID } from './pluginToolbarButtonsIds';
export { browser };

// TypeScript utilities
export { unreachable } from './Utils/tsUtils';
